import FAQ from "../../../components/FAQ";

// SMRU /RFC specific Q&A — rendered with the existing site FAQ component.
const SMRU_FAQS = [
  {
    q: "Is the B.Tech degree from St. Mary's University (SMRU) recognized?",
    a: "Yes. SMRU is a UGC 2(f) recognized university established under Telangana Govt. Act No. 10 of 2026, and the B.Tech degree is UGC & AICTE-approved.",
  },
  {
    q: "What makes AI.Prof × SMRU different from a regular B.Tech?",
    a: "Career preparation starts from Semester 1 — real projects from Day 1, AI tools integrated into every subject, a guaranteed internship, and direct access to 1,800+ hiring companies.",
  },
  {
    q: "Which specializations can I choose?",
    a: "AI & Machine Learning, Data Science, Cyber Security, Computer Science & Engineering, and Information Technology.",
  },
  {
    q: "Do I need prior coding experience to join?",
    a: "Not at all. Year 1 builds your foundation from scratch — you start coding in your very first week alongside Veda, your 24/7 AI co-pilot.",
  },
  {
    q: "Is the internship really guaranteed?",
    a: "Yes. Every student gets at least one guaranteed internship opportunity during the program through AI.Prof's network of 1,800+ companies.",
  },
  {
    q: "Where is the campus located?",
    a: "St. Mary's University, Deshmukhi Village — near Ramoji Film City, Hyderabad.",
  },
  {
    q: "Who is behind AI.Prof?",
    a: "AI.Prof is founded by Sandeep Konam — Forbes 30 Under 30, a Carnegie Mellon alumnus, and co-founder of Abridge, a $5.3B AI company.",
  },
  {
    q: "How do I apply?",
    a: "Tap “Get Guidance” to fill a 2-minute form. Our team will call you, help you pick the right specialization, and guide you through enrollment.",
  },
];

export default function SmruFaq() {
  return (
    <FAQ
      tag="Got Questions?"
      headline='Everything about <span class="text-aiblue">AI.Prof × SMRU</span>'
      items={SMRU_FAQS}
    />
  );
}
